

const Loading = () => {
    return (
        <div className="centered">
            <i className="fas fa-arrows-rotate fa-spin fa-3x fa-fw" />
            <p><strong>Loading...</strong></p>
        </div>
    )
}

export default Loading
